import React, { useRef, useEffect, useState } from "react";
import InputField from "../InputField";
import styled from "styled-components";
import { Colors } from "../../config";
import { addDays, format } from "date-fns";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import "./rangepicker.css";

const DateRangePickerInput = ({
  onDateSelection,
  label,
  start,
  end,
  minDate,
  helperText,
}) => {
  const [showOptions, setShowOptions] = useState(false);
  const [showEmpty, setShowEmpty] = useState(false);
  // console.log(start, end);
  const [state, setState] = useState([
    {
      startDate: start.length > 0 ? new Date(start) : new Date(),
      endDate:
        end.length > 0
          ? new Date(end)
          : new Date(Date.now() + 24 * 60 * 60 * 1000),
      key: "selection",
    },
  ]);

  const useOutsideAlerter = (ref) => {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setShowOptions(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  };

  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);

  const handleShow = (e) => {
    e.preventDefault();
    setShowOptions(true);
  };

  const handleSelection = (item) => {
    setShowEmpty(false);
    setState([item.selection]);
    onDateSelection(item.selection.startDate, item.selection.endDate);
    if (item.selection.startDate !== item.selection.endDate) {
      setShowOptions(false);
    }
  };

  const handleKeyDown = (e)=>{
    if(e.key === 'Backspace'){
      setShowEmpty(true);
      setState([{
        "startDate": new Date(),
        "endDate": new Date(Date.now() + 24 * 60 * 60 * 1000),
        "key": "selection"
    }])
    onDateSelection('', '');

    }
  }

  return (
    <TravelClassSelectWrapper ref={wrapperRef}>
      <InputField
        label={label}
        value={showEmpty ? 'Select Preferred Date':
          !start && !end
            ? "Select Preferred Date"
            : `${format(state[0].startDate, "ccc dd-MM-yyyy")} - ${format(
                state[0].endDate,
                "ccc dd-MM-yyyy "
              )}`
        }
        isRounded
        onFocus={(e) => handleShow(e)}
        onKeyDown={handleKeyDown}
        helperText={helperText}
      />
      {showOptions && (
        <Options>
          <div style={{ position: "relative" }}>
            <div style={{ position: "absolute", padding: "1rem" }}>
              {!start && !end
                ? ""
                : `${format(state[0].startDate, "ccc dd-MM-yyyy")} - ${format(
                    state[0].endDate,
                    "ccc dd-MM-yyyy "
                  )}`}
            </div>
          </div>
          <DateRangePicker
            onChange={(item) => handleSelection(item)}
            showSelectionPreview={false}
            moveRangeOnFirstSelection={false}
            months={2}
            ranges={state}
            direction="horizontal"
            preventSnapRefocus={false}
            calendarFocus="onwards"
            showMonthAndYearPickers={false}
            showDateDisplay={false}
            editableDateInputs={false}
            showPreview={false}
            color={Colors.pomegranate}
            rangeColors={[Colors.pomegranate]}
            minDate={minDate}
          />
        </Options>
      )}
    </TravelClassSelectWrapper>
  );
};

const Options = styled.div`
  position: absolute;
  width: auto;
  border-radius: 0.5rem;
  background: ${Colors.white};
  top: 4rem;
  left: -3rem;
  transform: scale(0.85);
  border: 1px solid ${Colors.sharkApproxOpacity40};
  display: flex;
  flex-direction: column;
  z-index: 9999;
  @media only screen and (max-width: 768px) {
    width: 100%;
    overflow: auto;
    left: 0;
  }
`;
const TravelClassSelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`;

export default DateRangePickerInput;
